import React, {useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { config } from 'src/env.js';
import { Container } from 'react-bootstrap';
import AboutModalComponent from 'src/components/general/AboutModalComponent';
import { tryGetVersionFundsRequestsApi, tryGetVersionCoreApi, tryGetVersionPresupuestoApi, tryGetVersionAuthApi } from 'src/redux/version/versionActionCreator';
import { getVersionFundsRequestsAPIData, getVersionFundsRequestsAPIIsFetching, getVersionCoreAPIData, getVersionCoreAPIIsFetching, getVersionPresupuestoAPIData, getVersionPresupuestoAPIIsFetching, getVersionAuthAPIData, getVersionAuthAPIIsFetching  } from 'src/redux/version/versionReducer';
import { logout } from 'src/redux/login/loginActions';
import { push } from 'connected-react-router';
import { LOGIN_URI } from 'src/utils/constants';
import '@n8n/chat/style.css';
import { createChat } from '@n8n/chat';
import { usePermissions } from '../general/menu/hooks/usePermissions';
import { getAlias, getEmail } from '../../redux/login/loginReducer';

const Footer = () => {
	const dispatch = useDispatch();
	const yearCurrent = new Date();
	const versionFundsRequestsAPIData = useSelector( state => getVersionFundsRequestsAPIData(state) );
	const versionFundsRequestsAPIIsFetching = useSelector( state => getVersionFundsRequestsAPIIsFetching(state) );
	const versionCoreAPIData = useSelector( state => getVersionCoreAPIData(state) );
	const versionCoreAPIIsFetching = useSelector( state => getVersionCoreAPIIsFetching(state) );
	const versionPresupuestoAPIData = useSelector( state => getVersionPresupuestoAPIData(state) );
	const versionPresupuestoAPIIsFetching = useSelector( state => getVersionPresupuestoAPIIsFetching(state) );
	const versionAuthAPIData = useSelector( state => getVersionAuthAPIData(state) );
	const versionAuthAPIIsFetching = useSelector( state => getVersionAuthAPIIsFetching(state) );
	const frontEnd = config?.appSettings?.version;
	const dataModal = {
		versionFundsRequestsAPIData : versionFundsRequestsAPIData,
		versionFundsRequestsAPIIsFetching : versionFundsRequestsAPIIsFetching, 
		versionCoreAPIData : versionCoreAPIData,
		versionCoreAPIIsFetching : versionCoreAPIIsFetching,
		versionPresupuestoAPIData : versionPresupuestoAPIData,
		versionPresupuestoAPIIsFetching : versionPresupuestoAPIIsFetching,
		versionAuthAPIData : versionAuthAPIData,
		versionAuthAPIIsFetching : versionAuthAPIIsFetching,
		frontEnd : frontEnd
	};

	const GET_STATUS_API = `${config.apis.coreApi.URL}/system-status-log`;

	const onChangeVersionApi = actualApiVersion => {
		if (frontEnd !== actualApiVersion) {
			swal({
				title: 'Actualización',
				text: 'Cambio la versión de la aplicación, debera reiniciar la sesión para ver los cambios',
				icon: 'warning'
			}).then(() => {
				dispatch(logout());
				dispatch(push(LOGIN_URI));
			});
		}
	}

	useEffect(() => {
        const fetchStatusApi = async () => {
            try {
                const response = await fetch(GET_STATUS_API);
                const data = await response.json();
                const version = data.records[0].frontendVersion;
                onChangeVersionApi(version);
            } catch (error) {
                console.error("Error fetching frontStatus:", error);
            }
        };
        fetchStatusApi();
        const intervalId = setInterval(() => {
            fetchStatusApi();
        }, 6000);
        return () => clearInterval(intervalId);
    }, []); 
	
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
		
	const onClickSeeAboutModal = () => {
		handleShow(true);
		dispatch( tryGetVersionFundsRequestsApi() ); 
		dispatch( tryGetVersionCoreApi() );
		dispatch( tryGetVersionPresupuestoApi() );
		dispatch( tryGetVersionAuthApi() );
	};

	const { profileName	} = usePermissions();
	const alias = useSelector(state => getAlias(state));
	const email = useSelector(state => getEmail(state));

	useEffect(() => {
		if (profileName && profileName.trim() !== ""){
			createChat({
				webhookUrl: `${config?.apis?.n8nApi?.WEBHOOK_URL}`,
				webhookConfig: {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
				},
				mode: 'window',
				chatInputKey: 'chatInput',
				chatSessionKey: 'sessionId',
				metadata: {
					alias: alias,
					userEmail: email,
					profileName: profileName,
				},
				showWelcomeScreen: false,
				defaultLanguage: 'en',
				initialMessages: [
					'¡Hola! 👋',
					'Soy CeGe el asistente de Inteligencia Artificial de la Contaduría, ¿cómo puedo ayudarte?',
				],
				i18n: {
					en: {
						title: 'Contaduría General Provincia de Misiones',
						subtitle: 'IA - Desarrollo',
						footer: '',
						getStarted: 'Nueva Conversación',
						inputPlaceholder: 'Escribe tu pregunta...',
						closeButtonTooltip: 'Cerrar conversación',
					},
				},
			});
		} else {
			// Eliminar manualmente el chatbot del DOM si el perfil cambia
			const chatElement = document.getElementById('n8n-chat');
			if (chatElement) {
				chatElement.remove();
			}
		}
		// Eliminar el chatbot al desmontar el componente
		return () => {
			const chatElement = document.getElementById('n8n-chat');
			if (chatElement) {
				chatElement.remove();
			}
		};
	}, [profileName, email]);

	return( <Container>
		<footer id='footer' className='row page-footer font-weight-light footer-container fixed-bottom'>
			<div className='col-md-12'>
				<div className='text-right py-1 px-3 text-white'>
					© {yearCurrent.getFullYear()} Copyright: {config.appSettings.name} - <a className='font-italic text-white cursor-pointer font-weight-bold' onClick={() => onClickSeeAboutModal()} >Acerca de...</a>
				</div>
			</div>
		</footer>

		<AboutModalComponent
			data={dataModal}
			title={'Acerca de...'}
			titleCard={config.appSettings.name}
			show={show}
			handleClose={handleClose}
		/>

	</Container>
	);
};

export default Footer;